import Link from 'next/link'

const HOST = process.env.NEXT_PUBLIC_HOST

const LINK_REGEXP = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?/g

export default function substituteLinks (text) {
    if (typeof text !== 'string' || !text.length) return text
    const linksPresent = text.match(LINK_REGEXP)

    if (!linksPresent) return text

    const links = linksPresent.map(link => {
      text = text.replace(link, ':cut:link:cut')

      return link.includes(HOST)
        ? <Link href={link.replace(HOST, '')}>{ link }</Link>
        : <a href={link} target="_blank" rel="noopener noreferrer">{ link }</a>
    })

    let linkIdx = 0
    return text.split(/:cut/g)
      .map(textOrLink => textOrLink === ':link'
        ? links[linkIdx++]
        : textOrLink)
  }